import { useEffect, useState } from "react"
import { Table, Form, Row, Col, InputGroup } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { getAnnualConstructionPercentage } from "../../../data/enumSlice"
import { actions } from "../../../data/applicationSlice"

const { updateApplicationData } = actions

const AnnualConstructionPercentage = ({ questionNumber, validationError, setValidationErrors }) => {
    const [columnsData, setColumnsData] = useState([])
    const dispatch = useDispatch()
    const { annualConstructionPercentage } = useSelector((state) => state.enums)
    const { application, fetchStatus } = useSelector((state) => state.application)
    const [totalPercent, setTotalPercent] = useState(0)
    const [leftColumnData, setLeftColumnData] = useState([])
    const [rightColumnData, setRightColumnData] = useState([])

    useEffect(() => {
        dispatch(getAnnualConstructionPercentage())
    }, [])

    useEffect(() => {
        if (validationError?.annualConstructionValuesTotalPercentage && totalPercent === 100) {
            setValidationErrors((preErrors) => {
                const newError = { ...preErrors }
                if (newError["annualConstructionValuesTotalPercentage"]) {
                    delete newError["annualConstructionValuesTotalPercentage"]
                }
                return newError
            })
        }
    }, [totalPercent])

    useEffect(() => {
        let percent = 0
        columnsData?.forEach((item) => {
            if (item.key.includes("Label")) {
                return
            }
            const value = parseInt(application[item.key] ?? 0)

            if (!isNaN(value)) {
                percent += value
            }
        })

        percent += parseInt(application.annualConstructionValueOther ?? 0)
        setTotalPercent(percent)
    }, [columnsData, fetchStatus])

    const handleInputChange = (event) => {
        const { value, name } = event.target
        if (name === "annualConstructionValueOtherLabel") {
            dispatch(
                updateApplicationData({
                    field: "annualConstructionValueOtherLabel",
                    value
                })
            )
            return
        }

        const numericValue = +value.replace(/\D/g, "")

        if (numericValue > 100) {
            alert("Percentage must be less than or equal to 100")
            return
        }

        dispatch(
            updateApplicationData({
                field: name,
                value: numericValue
            })
        )
    }

    useEffect(() => {
        const annualConstructionValues = Object.keys(application).filter((key) =>
            key.startsWith("annualConstructionValue")
        )

        const populatedAnnualConstructionValues = annualConstructionPercentage.map((item) => {
            const index = annualConstructionValues.findIndex((value) => value.id === item.id)
            if (index !== -1) {
                return { ...item, ...annualConstructionValues[index] }
            }
            return item
        })
        setLeftColumnData(populatedAnnualConstructionValues?.filter((item, index) => index % 2 === 0))
        setRightColumnData(populatedAnnualConstructionValues?.filter((item, index) => index % 2 !== 0))
        setColumnsData(populatedAnnualConstructionValues)
    }, [annualConstructionPercentage, fetchStatus])

    return (
        <div className="mt-4 percentages">
            <h6
                className={`
            ${validationError?.annualConstructionValuesTotalPercentage ? "text-error" : ""}
            `}>
                {questionNumber}. Please complete this table as it applies to percentage of annual construction values.
                Please note that percentages must add up to 100%.
            </h6>

            <Row>
                <Col className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Percentage of Annual Construction of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">{item.name}</td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                value={application[item.key] || ""}
                                                name={item.key}
                                                onChange={(e) => {
                                                    const copiedData = [...leftColumnData]

                                                    if (index != -1) {
                                                        copiedData[index] = {
                                                            ...copiedData[index],
                                                            value: +e.target.value
                                                        }
                                                    }
                                                    setLeftColumnData(copiedData)
                                                    setColumnsData([...copiedData, ...rightColumnData])
                                                    handleInputChange(e)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
                <Col className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Percentage of Annual Construction of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rightColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">
                                        {item.name === "Other (please describe)" ? (
                                            <Form.Control
                                                type="text"
                                                className="form-control-sm"
                                                placeholder="Other (please describe)"
                                                max={100}
                                                min={0}
                                                value={
                                                    typeof application["annualConstructionValueOtherLabel"] === "string"
                                                        ? application["annualConstructionValueOtherLabel"]
                                                        : ""
                                                }
                                                name={item.name === "Other (please describe)" ? "name" : ""}
                                                onChange={(e) => {
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name: "annualConstructionValueOtherLabel"
                                                        }
                                                    }

                                                    handleInputChange(event)
                                                }}
                                            />
                                        ) : (
                                            item.name
                                        )}
                                    </td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                value={
                                                    item.name === "Other (please describe)"
                                                        ? application["annualConstructionValueOther"]
                                                        : application[item.key] || ""
                                                }
                                                onChange={(e) => {
                                                    const copiedData = [...rightColumnData]
                                                    let index = copiedData?.findIndex((i) => i.id === item.id)

                                                    copiedData[index] = {
                                                        ...copiedData[index],
                                                        value: +e.target.value
                                                    }
                                                    setRightColumnData(copiedData)
                                                    setColumnsData([...copiedData, ...leftColumnData])
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name:
                                                                item.name === "Other (please describe)"
                                                                    ? "annualConstructionValueOther"
                                                                    : item.key
                                                        }
                                                    }
                                                    handleInputChange(event)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row>
                <Col>
                    <p className={totalPercent !== 100 ? "total-percent text-error" : "total-percent"}>
                        Total Percent: {totalPercent}%
                    </p>
                </Col>
            </Row>
        </div>
    )
}

export default AnnualConstructionPercentage
